<script lang="ts">
import Vue from 'vue';
import RecordingConsentModal from '@/components/modals/RecordingConsentModal.vue';

export default Vue.extend({
  name: 'RecordingConsentScreen',

  components: { RecordingConsentModal },

  props: {
    agreeBtnText: {
      type: String,
      required: true
    },
    leaveBtnText: {
      type: String,
      required: true
    },
    shouldCloseWindow: {
      type: Boolean,
      default: true
    }
  }
});
</script>

<template>
  <div
    class="recording-consent-screen-content"
    data-cy="recording-consent-screen-content"
  >
    <div class="content-div">
      <RecordingConsentModal
        :shouldCloseWindow="shouldCloseWindow"
        :agree-btn-text="agreeBtnText"
        :leave-btn-text="leaveBtnText"
      />
    </div>
  </div>
</template>

<style scoped>
.recording-consent-screen-content {
  color: #000000;
}
</style>
